import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CtrlCollection } from "@yuigoto/ctrl";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { PartnerInfoActions } from "state/actions/user/PartnerInfoActions";
import { SocialMediaControl } from "controls/SocialMediaControl";
import Styles from "views/pages/DadosPessoais.module.scss";
import { UiActions } from "state/actions/UiActions";
import { Container } from 'components/grid/Container';
import { Row } from 'components/grid/Row';
import { Col } from 'components/grid/Col';

class SocialMediaInfo extends Component {
  constructor(props) {
    super(props)

    let { partnerInfo } = this.props;

    this.collection = new CtrlCollection();
 
    for (let i in SocialMediaControl) {
      if (Array.isArray(SocialMediaControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n in SocialMediaControl[i]) {     
          
          SocialMediaControl[i][n].value = partnerInfo[SocialMediaControl[i][n].name];

          tempCollection.add(SocialMediaControl[i][n]);
        }

        this.collection.push(tempCollection);
      } else {
        let name = SocialMediaControl[i].name;
        let alias = SocialMediaControl[i].alias;

        SocialMediaControl[i].value = partnerInfo[alias] || partnerInfo[name];

        this.collection.add(SocialMediaControl[i]);
      }
    }

  }

  onSubmit=(event)=> {
    
    event.preventDefault();
    let isValid = this.collection.validate();

    if (!isValid) {

      this.forceUpdate();
      this.props.errorAlert("Campos inválidos"); 
      return;
    }
    else {

      let partner = this.props.partnerInfo;
      this.props.loaderShow();

      this.props.saveSocialData(
        Object.assign({},
          partner,
          this.collection.toObject(true),
          { access_token: this.props.token.access_token }
        ),
        (response) => {
          const {
            result,
            statusCode
          } = response;

          this.props.loaderHide();

          if (statusCode === 200) {
            this.props.successAlert(
              result && result.message
                ? result.message
                : "Atualizado com sucesso"
            );
          }
          else {
            this.props.errorAlert(
              result && result.message
                ? result.message
                : "Não foi possível atualizar seus dados"
            );
          }
        }
      );
      }
    }
  

  render() {
    return (
      <Container fluid>
        <Row>
          <Col xs={12} md={6}>
              <div className={"gb-contentblock p-4 level-2 mb-2"}>
                <form onSubmit={this.onSubmit}>
                  {ControlRenderer.renderCollection(this.collection)}

                  <div className={Styles['info__buttons']}>
                    <button type={"submit"} className={"btn btn-light-pink btn-md"}>
                      Alterar Dados
                      </button>
                  </div>
                </form>
              </div>
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  partnerInfo: state.partnerInfo.data,
  token: state.token.data

})

const mapDispatchToProps = (dispatch) => ({
  saveSocialData: (partner, callback) => {
    dispatch(PartnerInfoActions.savePartnerData(partner, callback))
  },
  successAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message))
  },
  errorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message))
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow())
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide())
  },
  saveSocialData: (partner, callback) => {
    dispatch(PartnerInfoActions.saveSocialData(partner, callback))
  }
  
})

SocialMediaInfo = connect(mapStateToProps, mapDispatchToProps)(SocialMediaInfo);

export { SocialMediaInfo };